import React from 'react';
import { Button, Icon } from 'designSystem';
import { useTheme } from 'styled-components';
export var PDFDownloadButtonView = function (_a) {
    var loading = _a.loading, onDownload = _a.onDownload;
    var theme = useTheme();
    return (React.createElement(Button, { variant: "outlinedSecondary", startIcon: React.createElement(Icon, { name: loading ? 'loading' : 'download', size: 12, color: theme.colors.text.base }), onClick: onDownload, size: "small" }, "PDF"));
};
